export default __webpack_public_path__ + "static/media/america.70c96f86.jpg";